/* import __COLOCATED_TEMPLATE__ from './likes-list-empty-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();